import { Injectable} from '@angular/core';
import { catchError, Observable, throwError } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '@env/environment';
import { Page } from '../commons/page';
import { InvoiceMetaData } from './models/invoice-meta-data.model';
import { HttpUtilService } from '../http.util.service';

@Injectable({
  providedIn: 'root'
})
export class InvoiceService {

  constructor(private httpClient: HttpClient, private httpUtilService: HttpUtilService) { }

  public getInvoiceData(mobilityAccountId: number, subscriptionId: number, sortOrder = 'DESC', sortElement = 'dispatchDate', pageNumber = 0, pageSize = 10): Observable<Page<InvoiceMetaData>> {
    switch (sortElement) {
      case 'REFERENCE':
        sortElement = 'reference';
        break;
      case 'AMOUNT_TTC':
        sortElement = 'priceInclTax';
        break;
      case 'STATUS':
        sortElement = 'status';
        break;
      default:
        sortElement = 'dispatchDate';
    }

    const params = this.httpUtilService.buildHttpParams({
      customerToken: mobilityAccountId.toString(),
      subscriptionId: subscriptionId.toString(),
      sort: `${sortElement},${sortOrder}`,
      page: pageNumber.toString(),
      size: pageSize.toString()
    });

    const headers = this.httpUtilService.buildHeaders();

    return this.httpClient.get<Page<InvoiceMetaData>>(`${environment.api.mobilityUrl}/api/invoicing-manager/v1/invoices`, { params, headers }).pipe(
      catchError(_err => {
        if (_err.status === 403) {
          console.error(`The agent doesn't have the permission to get invoices`);
        }
        console.error(_err);
        return throwError(() => _err);
      })
    );
  }

  downloadInvoice(reference: string, serviceEmitter: string): Observable<any> {
    return this.httpClient.get(`${environment.api.mobilityUrl}/api/invoicing-manager/v1/services/${serviceEmitter}/invoices/${reference}/_download`, {
      responseType: 'arraybuffer',
      headers: new HttpHeaders({
        'x-apikey': environment.api.apikey
      })
    });
  }
}
